import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IDeleteFacesFeature, IVertexGroup } from '../kb3d-models';
import { Token } from '../token';
import { Feature, eMeshChangeTypes } from './feature';

@Kb3dModel({
    token: Token.DeleteFacesFeature,
})
export class DeleteFacesFeature extends Feature implements IDeleteFacesFeature {
    static _dependsOn = new Set([eMeshChangeTypes.VertexIndices]);
    static _affects = new Set([eMeshChangeTypes.VertexIndices, eMeshChangeTypes.Submeshes]);
    static _affectedBy = new Set([eMeshChangeTypes.VertexIndices, eMeshChangeTypes.Submeshes]);

    vertexGroups: Array<Required<IVertexGroup>> = [];
}
